import { render, staticRenderFns } from "./LocalityCrud.vue?vue&type=template&id=9a545436"
import script from "./LocalityCrud.vue?vue&type=script&lang=js"
export * from "./LocalityCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports